import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/apps/dashboard-app/app/(public)/forgot-password/form.tsx");
